
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 10.41a1.963 1.963 0 00-.09-.405V9.87a1.604 1.604 0 00-.285-.42l-9-9a1.606 1.606 0 00-.42-.285h-.15A1.65 1.65 0 0013.59 0H4.5A4.5 4.5 0 000 4.5v21A4.5 4.5 0 004.5 30h15a4.5 4.5 0 004.5-4.5v-15-.09zm-9-5.295L18.885 9H16.5A1.5 1.5 0 0115 7.5V5.115zM21 25.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 25.5v-21A1.5 1.5 0 014.5 3H12v4.5a4.5 4.5 0 004.5 4.5H21v13.5zm-7.065-7.065l-.435.45V15a1.5 1.5 0 10-3 0v3.885l-.435-.45a1.506 1.506 0 10-2.13 2.13l3 3a1.5 1.5 0 00.495.315 1.41 1.41 0 001.14 0 1.5 1.5 0 00.495-.315l3-3a1.506 1.506 0 10-2.13-2.13z"}})])
          )
        }
      }
    